import React from 'react';
import * as Styles from './ProductsOffer.styles';
import {
  WhiteCard, WhiteCardContent, WhiteCardHeader, Title, Subtitle, WrapperCardsProducts,
} from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import vpsOpenClawImage from '@/pages/Home/media/products-offer/vps-open-claw-br.png';
import vpsN8nImage from '@/pages/Home/media/products-offer/vps-n8n-br.png';
import dedicatedLinuxServerImageBr from '@/pages/Home/media/products-offer/dedicated-linux-server-br.png';
import dedicatedLinuxServerImageEs from '@/pages/Home/media/products-offer/dedicated-linux-server-es.png';
import iconSnappy from '@/pages/Home/media/products-offer/icon-snappy.svg';
import { PRODUCTS_OFFER_IDS } from './ProductsOffer.enum';
import { CardProduct } from '../CardProduct';
import { isBRServer } from '@/utils/Validators/validation';

const getProductsPriceList = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.prices)) return raw.prices;
  return [];
};

const getOfferPriceByProductType = (productsOfferData, apiType) => {
  if (!apiType) return undefined;
  const entry = getProductsPriceList(productsOfferData).find(item => item.type === apiType);
  return entry?.cycles?.triennially?.price?.discounts?.[0]?.per_month;
};

const getDiscountByProductType = (productsOfferData, apiType) => {
  if (!apiType) return undefined;
  const entry = getProductsPriceList(productsOfferData).find(item => item.type === apiType);
  return entry?.cycles?.triennially?.price?.discounts?.[0]?.percentage_total;
};

const IMAGES = {
  [PRODUCTS_OFFER_IDS.VPS_OPEN_CLAW]: vpsOpenClawImage,
  [PRODUCTS_OFFER_IDS.VPS_N8N]: vpsN8nImage,
  [PRODUCTS_OFFER_IDS.DEDICATED_LINUX_SERVER]: isBRServer ? dedicatedLinuxServerImageBr : dedicatedLinuxServerImageEs,
};

const ProductsOffer = ({
  locale, cardsActions, productsOfferData,
}) => (
  <WhiteCard data-testid="products-offer">
    <WhiteCardContent>
      <Styles.BgProductOffer />
      <Styles.HeaderProductOffer>
        <Styles.IconSnappyProductOffer src={iconSnappy} alt="Icon Snappy" />

        <WhiteCardHeader>
          <Title>{locale.title}</Title>
          <Subtitle>{locale.description}</Subtitle>
        </WhiteCardHeader>
      </Styles.HeaderProductOffer>

      <WrapperCardsProducts>
        {Object.values(locale.products).map(product => (
          <CardProduct
            key={`product-offer-card-${product.id}`}
            locale={locale}
            image={IMAGES[product.id]}
            title={product.name}
            description={product.description}
            buttonPrimaryLabel={locale.cta}
            buttonPrimaryOnClick={cardsActions[product.id]?.onClick}
            price={getOfferPriceByProductType(productsOfferData, product.id)}
            pricePrefix={locale.pricesText.pricePrefix}
            priceSuffix={isBRServer ? locale.pricesText.priceSuffix : locale.pricesText.priceSuffix()}
            discount={locale.pricesText.discount(getDiscountByProductType(productsOfferData, product.id))}
          />
        ))}
      </WrapperCardsProducts>
    </WhiteCardContent>
  </WhiteCard>
);

export default ProductsOffer;
